import { Link } from "gatsby";
import BackgroundImage from "gatsby-background-image";
import { convertToBgImage } from "gbimage-bridge";
import * as React from "react";
import { useSelector } from "react-redux";
import Col from "../../global/Col/Col";
import { container, title } from "./MediaCta.module.scss";
import { IMediaCta } from "./MediaCtaProps";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const Banner: React.FC<IMediaCta> = (props) => {
  const HR = "/join-travel-pass";
  const isLoggedIn = useSelector((state: any) => state.member.isLoggedIn);
  const _image = props.relationships.field_media.relationships.desktopImage;
  const _bgImage = convertToBgImage(_image);
  const logo = props.relationships.field_media
    ? props.relationships.field_media.relationships.field_logo &&
      props.relationships.field_media.relationships.field_logo.relationships
        .field_media_file.publicUrl
    : null;
  const fieldMedia = props.relationships.field_media;
  const title = fieldMedia && fieldMedia.field_title;
  const description = fieldMedia && fieldMedia.field_description;
  const link = fieldMedia && fieldMedia.field_link;
  const learnMoreLink = fieldMedia && fieldMedia.field_learn_more_link;
  const isHRAndLoggedIn = link && isLoggedIn && link.url.toLowerCase() === HR;
  return (
    <BackgroundImage
      {..._bgImage}
      preserveStackingContext
      className={container}
    >
      <div className="overlay rounded" />
      {logo && (
        <Col className={`col2`}>
          <img src={logo} alt={title || "Travel Pass"} className="logo" />
        </Col>
      )}
      {props.relationships && (
        <Col className={`col7`}>
          <div>
            <Title>{title}</Title>
            <p className="description mb-3">{description}</p>
            <div className={`buttonContainer`}>
              {link && (
                <Link to={isHRAndLoggedIn ? "/account" : link.url || ""}>
                  {isHRAndLoggedIn ? "View Account" : link.title}
                </Link>
              )}
              {learnMoreLink && (
                <Link
                  aria-label={`Learn More for ${title}`}
                  to={learnMoreLink.url || "/travel-pass"}
                  className="teaser-link text-white align-self-center"
                >
                  {learnMoreLink.title || "Learn More"}
                </Link>
              )}
            </div>
          </div>
        </Col>
      )}
    </BackgroundImage>
  );
};

export const Title: React.FC<any> = (props) => {
  return <div className={title}>{props.children}</div>;
};
